<template>
  <ClinicalTrialsView :mesh="$route.params.mesh"
                      :mesh-presentation-string="$route.params.meshPresentation"
                      :mesh-description="$route.params.meshDescription">
  </ClinicalTrialsView>
</template>

<script>
import ClinicalTrialsView from '@/components/ClinicalTrialsView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'clinical-trials-page',
  components: {
    ClinicalTrialsView
  }
});
</script>
